import type { Project } from '../../../shared/issuesV2';
import { EnumReachableNone } from '../../../shared/reachability/types';

/**
 * Check if an issue project is reachable.
 */
export function isProjectReachable(project: Project): boolean {
  if (!project.reachability) {
    return false;
  }
  return project.reachability.reachable !== EnumReachableNone;
}

/**
 * Check if any issue projects are reachable.
 */
export function areAnyProjectsReachable(projects: Project[]): boolean {
  return projects.some(isProjectReachable);
}
